import React from 'react'
import Link from 'gatsby-link'
import Instagram from '../components/Instagram'
import PhotoRow from '../components/PhotoRow'

const PHOTO_ROW_HEIGHT = 500
const TITLES = ['Endorfiny', 'Zábava', 'Dřina', 'Kolektiv', 'Pot']

const IndexPage = ({ data }) => (
  <article className="u-center">
    <h1>Muvko</h1>
    <p>Skupina sportovních nadšenců, kteří hledají každou záminku k tvrdému tréninku. Přidej se k nám a přijď se zapotit!</p>
    <PhotoRow
      images={data.allFile.edges}
      height={PHOTO_ROW_HEIGHT}
      titles={TITLES}
    />
    <Link to="/treninky">Koukni kdy si můžeš zatrénovat s námi.</Link>
    <div className="u-row">
      <h3>Sleduj nás na Instagramu</h3>
      <Instagram />
    </div>
  </article>
)

export default IndexPage

export const query = graphql`
query Images {
  allFile(limit: 5, sort: {fields: [name], order: ASC}, filter: {relativeDirectory: {eq: "homepage"}}) {
    edges {
      node {
        name
        publicURL
        prettySize
        childImageSharp {
          resize(height: 500, quality: 100, toFormat: JPG, jpegProgressive: true) {
            src
            width
            height
            aspectRatio
          }
        }
      }
    }
  }
}
`




// WEBPACK FOOTER //
// ./src/pages/index.js